import React from "react";
import { Send, RotateCcw, Check, X, PenSquare, FileText } from "lucide-react";

/**
 * Chronological negotiation log for a Variation Order.
 * Renders every action entry stored on `vo.timeline`.
 */
const META = {
  created:             { icon: FileText,   label: "Drafted",             tint: "bg-[#F7F4EC] text-[#7A7571]" },
  sent:                { icon: Send,       label: "Sent to homeowner",   tint: "bg-[#E0E7FF] text-[#3730A3]" },
  revision_requested:  { icon: RotateCcw,  label: "Sent back for edits", tint: "bg-[#FED7AA] text-[#9A3412]" },
  revised:             { icon: PenSquare,  label: "Revised & resent",    tint: "bg-[#E0E7FF] text-[#3730A3]" },
  approved:            { icon: Check,      label: "Approved",            tint: "bg-[#DCFCE7] text-[#166534]" },
  rejected:            { icon: X,          label: "Rejected",            tint: "bg-[#FEE2E2] text-[#991B1B]" },
};

export default function VOTimeline({ timeline = [] }) {
  if (!timeline || timeline.length === 0) return null;
  // Newest first
  const entries = [...timeline].sort((a, b) => (b.at || "").localeCompare(a.at || ""));

  return (
    <div className="mt-3 rounded-2xl border border-[#EBE5D9] bg-[#FBF7EF]/60 p-3">
      <div className="text-[10px] uppercase tracking-widest font-bold text-[#7A7571] mb-2">
        Negotiation timeline
      </div>
      <ol className="space-y-2">
        {entries.map((e) => {
          const m = META[e.action] || { icon: FileText, label: e.action, tint: "bg-[#F7F4EC] text-[#7A7571]" };
          const Icon = m.icon;
          return (
            <li key={e.entry_id} className="flex gap-2" data-testid={`vo-timeline-${e.entry_id}`}>
              <span className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 ${m.tint}`}>
                <Icon size={13} />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-baseline gap-2 flex-wrap">
                  <span className="text-sm font-semibold text-[#2C2A29]">{m.label}</span>
                  <span className="text-[11px] text-[#7A7571]">
                    {e.actor_name || (e.actor_role === "customer" ? "Homeowner" : "Team")}
                    {" · "}
                    {new Date(e.at).toLocaleString(undefined, { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" })}
                  </span>
                  {e.snapshot && typeof e.snapshot.cost_delta === "number" && (
                    <span className="text-[11px] font-semibold text-[#E07A5F]">
                      ${Number(e.snapshot.cost_delta).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  )}
                </div>
                {e.note && (
                  <div className="text-xs text-[#2C2A29] mt-0.5 whitespace-pre-wrap italic">
                    &quot;{e.note}&quot;
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
